export const consentResolver = (consents: Consents): boolean => {
  return consents.geoRequiresSignal
    ? !consents.ccpaSignal
    : consents.geoRequiresConsent
      ? consents.gdprConsent
      : true;
};
